var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"facebook-link",attrs:{"href":"https://www.facebook.com/pages/GradImages/164511703590505","target":"_blank","aria-label":"FaceBook"}},[_c('img',{staticClass:"facebook-link__img",attrs:{"src":_vm.imgFacebookCircleLogo,"alt":"Facebook Logo"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58481102","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./WebResources/vue/grad-images/site-footer/components/FacebookLink.vue
// module id = 1768
// module chunks = 27